import { THUMBNAIL_HEIGHT } from '@app/core/thumbnails/consts';
import { StreamEl, theme } from '@mi-front/ui';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { getThreeTranscriptionWords } from '../utils';

interface Props {
  data: any[];
  ts: number;
}

export const DiarizarionFrame = styled.div`
  border-radius: 6px;
  background-color: ${theme.aquaLight};
  border: 1px solid ${theme.aqua};
  width: 208px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 12px;
`;

export function StreamDiarization({ data, ts }: Props) {
  const words = useRef<string | null>('');
  useEffect(() => {
    words.current = getThreeTranscriptionWords(data, ts);
  }, [ts, data]);
  return words.current ? (
    <StreamEl
      ts={ts}
      checkOverflow
      offsetX={10}
      offsetY={THUMBNAIL_HEIGHT + 36}
      zIndex={100}
      position="center"
      noEvents
    >
      <DiarizarionFrame>{words.current}</DiarizarionFrame>
    </StreamEl>
  ) : null;
}
